import { render, staticRenderFns } from "./DEXT5Upload.vue?vue&type=template&id=a882cb4e"
import script from "./DEXT5Upload.vue?vue&type=script&lang=js"
export * from "./DEXT5Upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a882cb4e')) {
      api.createRecord('a882cb4e', component.options)
    } else {
      api.reload('a882cb4e', component.options)
    }
    module.hot.accept("./DEXT5Upload.vue?vue&type=template&id=a882cb4e", function () {
      api.rerender('a882cb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DEXT5Upload.vue"
export default component.exports